import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import ImageContentful from "./ImageContentful"

import { media } from "../styles"

export const Logos = styled.ul`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  gap: 20px;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;

  ${(props) =>
    props.$compact &&
    css`
      gap: 16px;

      ${Logo} {
        width: 80px;
      }
    `}

  @media ${media.md} {
    justify-content: flex-start;
  }
`

export const Logo = styled.li`
  flex: none;
  height: auto;
  margin: 0;
  padding: 0;
  width: 100px;

  ${(props) =>
    props.$compact &&
    css`
      width: 85px;
    `}

  img,
  svg {
    display: block;
    filter: saturate(0%) brightness(70%) contrast(1000%);
    height: auto;
    width: 100%;
  }
`

export const Header = styled.div`
  font-size: 15px;
  margin: 0 0 10px;
  opacity: 0.5;
  text-align: center;

  @media ${media.md} {
    text-align: left;
  }

  @media ${media.lg} {
    font-size: 17px;
    margin-bottom: 20px;
  }
`

const LogoRow = ({ compact, name, logos, className }) => {
  return (
    <div className={className}>
      <Header>{name}</Header>
      <Logos $compact={compact}>
        {logos.map((logo) => (
          <Logo key={logo.name}>
            <ImageContentful
              alt={logo.name}
              image={logo.logoInlined || logo.logoAligned || logo.logo}
              inline
            />
          </Logo>
        ))}
      </Logos>
    </div>
  )
}

LogoRow.propTypes = {
  compact: PropTypes.bool,
  name: PropTypes.string,
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      logoInlined: PropTypes.object,
      logoAligned: PropTypes.object,
      logo: PropTypes.object,
    })
  ).isRequired,
}

export default LogoRow
